import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import store from "../Store";
import Constants from "../Constants";
import Video from "./Video";
import Error404 from "./Error404";

import "./Project.css";

const find = require("lodash/find");
const findIndex = require("lodash/findIndex");

export default class Project extends Component {
	constructor(props) {
		super(props);

		this.state = this.processProps(props);

		// console.log(`this.state`, this.state);
	}

	processProps = props => {
		const data = find(store.data, item => {
			return item.id === props.id;
		});

		const index = findIndex(store.data, item => {
			return item.id === props.id;
		});

		const prevIndex = index > 0 ? index - 1 : store.data.length - 1;
		const nextIndex = index < store.data.length - 1 ? index + 1 : 0;

		// console.log(`index`, index, `prevIndex`, prevIndex, `nextIndex`, nextIndex);

		const prevId = store.data[prevIndex].id;
		const nextId = store.data[nextIndex].id;

		return {
			data,
			nextId,
			prevId,
			navigateTo: null,
			hasTouch: "ontouchstart" in document.documentElement,
		};
	};

	componentWillReceiveProps = nextProps => {
		// console.log(`componentWillReceiveProps`);
		this.setState(this.processProps(nextProps));
	};

	createMarkup = desc => {
		return { __html: desc.join("") };
	};

	componentDidMount = () => {
		document.addEventListener("keyup", this.handleKey);
	};

	componentWillUnmount = () => {
		document.removeEventListener("keyup", this.handleKey);
	};

	handleKey = event => {
		// console.log("handleKey", event, this.state);

		const { prevId, nextId, data } = this.state;

		if (event.key === "ArrowRight") {
			this.setState({ navigateTo: `/${nextId}` });
		} else if (event.key === "ArrowLeft") {
			this.setState({ navigateTo: `/${prevId}` });
		} else if (event.key === "Escape") {
			this.setState({ navigateTo: `/` });
		} else if (event.key === "Enter") {
			if (data.url !== "") {
				window.open(data.url, "_blank");
			}
		}
	};

	extractHostname = url => {
		var hostname;
		//find & remove protocol (http, ftp, etc.) and get hostname

		if (url.indexOf("://") > -1) {
			hostname = url.split("/")[2];
		} else {
			hostname = url.split("/")[0];
		}

		//find & remove port number
		hostname = hostname.split(":")[0];
		//find & remove "?"
		hostname = hostname.split("?")[0];

		return hostname;
	};

	render() {
		const { data, prevId, nextId, navigateTo } = this.state;

		// console.log(`navigateTo`, navigateTo);

		if (navigateTo) {
			return <Redirect push to={navigateTo} />;
		}

		if (data) {
			const { name, tags, src, url, video, desc, poster } = data;

			let visual = null;

			if (video) {
				visual = (
					<Video
						src={`${Constants.VIDEO_PATH_PREFIX}${video[0]}`}
						poster={`${Constants.IMAGE_PATH_PREFIX}${poster ? poster : src[0]}`}
					/>
				);
			} else {
				visual = (
					<img src={`${Constants.IMAGE_PATH_PREFIX}${src[0]}`} alt={name} />
				);
			}

			return (
				<div
					className="Project"
					ref={node => {
						this.element = node;
					}}
				>
					<div className="Visual">{visual}</div>
					<Link to={`/${prevId}`} className="Menu Left">
						&larr; Previous
					</Link>
					<Link to="/" className="Menu Close">
						<span>&times;</span>
					</Link>
					<Link to={`/${nextId}`} className="Menu Right">
						Next &rarr;
					</Link>
					<div className="Meta">
						<h1 dangerouslySetInnerHTML={this.createMarkup([name])} />
						{desc && <div dangerouslySetInnerHTML={this.createMarkup(desc)} />}
						{url && (
							<div>
								<a href={url} target="blank">
									&rarr; View Project <span>({this.extractHostname(url)})</span>
								</a>
							</div>
						)}
						<div className="Tags">
							{tags.map((tag, tagIndex) => {
								return tagIndex !== tags.length - 1 ? `${tag}, ` : `${tag}`;
							})}
						</div>
						{/* <div>{src[0]}</div> */}
						{!this.state.hasTouch && (
							<div className="Keys">
								<div className="Key">
									<span>&rarr;</span>Next
								</div>

								<div className="Key">
									<span>&larr;</span>Previous
								</div>

								<div className="Key">
									<span>&crarr;</span>View
								</div>

								<div className="Key">
									<span>esc</span>Close
								</div>

								{video && (
									<div className="Key">
										<span>space</span>Play&nbsp;Video
									</div>
								)}
							</div>
						)}
					</div>
				</div>
			);
		} else {
			return <Error404 message="Sorry. Project not found." />;
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/Project.js